import { render } from "./Quotations.vue?vue&type=template&id=070afa95&scoped=true"
import script from "./Quotations.vue?vue&type=script&lang=js"
export * from "./Quotations.vue?vue&type=script&lang=js"

import "./Quotations.vue?vue&type=style&index=0&id=070afa95&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-070afa95"

export default script